import { get_asset_preview_element_id } from '@/lib/asset-preview-id';

export type AssetIndexBySequenceNumber = Map<number, number>;

export type PortfolioNavigationSectionId =
  | 'brand-design'
  | 'packaging-design'
  | 'other-design'
  | 'ecommerce-design';

export type PortfolioNavigationItem = {
  end_asset_sequence_number: number;
  label: string;
  section_id: PortfolioNavigationSectionId;
  start_asset_sequence_number: number;
  target_asset_sequence_number: number;
};

export const PORTFOLIO_NAVIGATION_ITEMS: PortfolioNavigationItem[] = [
  {
    end_asset_sequence_number: 43,
    label: '品牌设计',
    section_id: 'brand-design',
    start_asset_sequence_number: 1,
    target_asset_sequence_number: 4,
  },
  {
    end_asset_sequence_number: 61,
    label: '包装设计',
    section_id: 'packaging-design',
    start_asset_sequence_number: 44,
    target_asset_sequence_number: 44,
  },
  {
    end_asset_sequence_number: 81,
    label: '其他设计',
    section_id: 'other-design',
    start_asset_sequence_number: 62,
    target_asset_sequence_number: 62,
  },
  {
    end_asset_sequence_number: 96,
    label: '电商设计',
    section_id: 'ecommerce-design',
    start_asset_sequence_number: 82,
    target_asset_sequence_number: 82,
  },
];

export function get_active_navigation_section_id(asset_sequence_number: number) {
  const active_navigation_item = PORTFOLIO_NAVIGATION_ITEMS.find(
    navigation_item =>
      asset_sequence_number >= navigation_item.start_asset_sequence_number &&
      asset_sequence_number <= navigation_item.end_asset_sequence_number,
  );

  return active_navigation_item?.section_id ?? null;
}

export function create_asset_index_by_sequence_number(
  asset_sequence_entries: Array<readonly [number, number]>,
): AssetIndexBySequenceNumber {
  const first_asset_sequence_entries = asset_sequence_entries.filter(
    ([asset_sequence_number], entry_index) =>
      asset_sequence_entries.findIndex(
        ([candidate_asset_sequence_number]) =>
          candidate_asset_sequence_number === asset_sequence_number,
      ) === entry_index,
  );

  return new Map(first_asset_sequence_entries);
}

export function scroll_to_navigation_item({
  asset_index_by_sequence_number,
  navigation_item,
}: {
  asset_index_by_sequence_number: AssetIndexBySequenceNumber;
  navigation_item: PortfolioNavigationItem;
}) {
  const target_asset_index = asset_index_by_sequence_number.get(
    navigation_item.target_asset_sequence_number,
  );

  if (target_asset_index === undefined) {
    return;
  }

  document.getElementById(
    get_asset_preview_element_id(target_asset_index),
  )?.scrollIntoView(get_navigation_scroll_options());
}

export function get_navigation_scroll_options(): ScrollIntoViewOptions {
  return {
    behavior: 'smooth',
    block: 'center',
  };
}

export function get_portfolio_navigation_item(
  section_id: PortfolioNavigationSectionId,
) {
  const navigation_item = PORTFOLIO_NAVIGATION_ITEMS.find(
    portfolio_navigation_item =>
      portfolio_navigation_item.section_id === section_id,
  );

  if (!navigation_item) {
    throw new Error(
      `get_portfolio_navigation_item failed: unknown section_id=${section_id}`,
    );
  }

  return navigation_item;
}
